/**
 * @description: 进销存报表
 * @author: hwx
 * @author: lyr(2022-03-14)
*/
<template>
    <div class="sr-jxc-report">
        <div class="jxc-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="jxc_time">
                        <input type="text" class="form-control laydate-icon" v-model="jxc_start_time"> -
                        <input type="text" class="form-control laydate-icon" v-model="jxc_end_time">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="jxc_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="jxc_stock" data-placeholder="请选择仓库">
                    </select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" v-model="jxc_gtype_txt" ref="jxc_gtype_txt" placeholder="请选择商品类型" readonly @click="jxcGtypeFun()">
                    <span class="selection-clear" @click="clearInput">×</span>
                    <span class="span-arrow"><b></b></span>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="jxc_goods_name">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getJxcExportSet">导出</button>
                </div>
            </div>
            <div class="total-row">
                <div class="item">期初总量：{{total_start_stock}}</div>
                <div class="item">入库总量：{{total_in_total}}</div>
                <div class="item">出库总量：{{total_out_total}}</div>
                <div class="item">期末总量：{{total_end_stock}}</div>
                <div class="item">期末总金额：{{total_amount}}</div>
            </div>

            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="store_name" label="仓库"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称" width="120"></el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="start_stock" label="期初数量"></el-table-column>
                <el-table-column prop="purchase_in" label="采购入库数量"></el-table-column>
                <el-table-column prop="give_in" label="赠送入库数量"></el-table-column>
                <el-table-column prop="transfer_in" label="调拨入库数量"></el-table-column>
                <el-table-column prop="exchange_in" label="换货入库数量"></el-table-column>
                <el-table-column prop="refund_in" label="商品退货入库数量"></el-table-column>
                <el-table-column prop="profit_in" label="盈余入库数量"></el-table-column>
                <el-table-column prop="legacy_in" label="客遗入库数量"></el-table-column>
                <el-table-column prop="deposit_in" label="寄存入库数量"></el-table-column>
                <el-table-column prop="confiscate_in" label="充公入库数量"></el-table-column>
                <el-table-column prop="cancel_confiscate_in" label="取消充公入库数量"></el-table-column>
                <el-table-column prop="inventory_profit_in" label="盘盈入库数量"></el-table-column>
                <el-table-column prop="in_total" label="入库总数量"></el-table-column>
                <el-table-column prop="sale_out" label="商品销售数量"></el-table-column>
                <el-table-column prop="give_out" label="商品赠送数量"></el-table-column>
                <el-table-column prop="present_out" label="商品例送数量"></el-table-column>
                <el-table-column prop="snack_out" label="开房小吃数量"></el-table-column>
                <el-table-column prop="transfer_out" label="调拨出库数量"></el-table-column>
                <el-table-column prop="inventory_losse_out" label="盘亏出库数量"></el-table-column>
                <el-table-column prop="deposit_out" label="取酒出库数量"></el-table-column>
                <el-table-column prop="confiscate_out" label="充公出库数量"></el-table-column>
                <el-table-column prop="cancel_confiscate_out" label="取消充公出库数量"></el-table-column>
                <el-table-column prop="deposit_to_void" label="寄存作废出库数量"></el-table-column>
                <el-table-column prop="refund_out" label="采购退货出库数量"></el-table-column>
                <el-table-column prop="receive_out" label="领用出库数量"></el-table-column>
                <el-table-column prop="breakage_out" label="报损出库数量"></el-table-column>
                <el-table-column prop="out_total" label="出库总数量"></el-table-column>
                <el-table-column prop="end_stock" label="期末数量"></el-table-column>
                <el-table-column prop="price" label="进货价"></el-table-column>
                <el-table-column prop="amount" label="金额"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="page_size"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getListTable">
            </el-pagination>
            <!-- 商品类型弹窗 -->
            <div class="ele-hide" ref="jxc_gtype_alert">
                <div class="multi-select">
                    <div class="clearfix">
                        <input type='checkbox' v-model='jxc_gtype_all' @click='jxcGtypeAll'>
                        <span>全选</span>
                    </div>
                    <ul class="clearfix">
                        <li v-for="item in jxc_gtype_arr">
                            <input type="checkbox" v-model='jxc_gtype_item' :value="item.id">
                            <span>{{item.text}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="jxcExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='jxcExport_allcheck' @click='jxcExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="store_name">
                            <label>仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="start_stock">
                            <label>期初数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="purchase_in">
                            <label>采购入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="give_in">
                            <label>赠送入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="transfer_in">
                            <label>调拨入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="exchange_in">
                            <label>换货入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="refund_in">
                            <label>商品退货入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="profit_in">
                            <label>盈余入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="legacy_in">
                            <label>客遗入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="deposit_in">
                            <label>寄存入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="confiscate_in">
                            <label>充公入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="cancel_confiscate_in">
                            <label>取消充公入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="inventory_profit_in">
                            <label>盘盈入库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="in_total">
                            <label>入库总数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="sale_out">
                            <label>商品销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="give_out">
                            <label>商品赠送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="present_out">
                            <label>商品例送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="snack_out">
                            <label>开房小吃数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="transfer_out">
                            <label>调拨出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="inventory_losse_out">
                            <label>盘亏出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="deposit_out">
                            <label>取酒出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="confiscate_out">
                            <label>充公出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="cancel_confiscate_out">
                            <label>取消充公出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="deposit_to_void">
                            <label>寄存作废出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="refund_out">
                            <label>采购退货出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="receive_out">
                            <label>领用出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="breakage_out">
                            <label>报损出库数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="out_total">
                            <label>出库总数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="end_stock">
                            <label>期末数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="price">
                            <label>进货价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jxcExport_checkModel' value="amount">
                            <label>金额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='jxcExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <!-- <li>
                            <input type="radio" v-model='jxcExport_type' value="2">
                            <label>pdf文件</label>
                        </li> -->
                    </ul>
                    <!-- </div> -->
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                jxc_start_time: "",
                jxc_end_time: "",
                jxc_gtype_txt: "",
                jxc_gtype_all: false,
                c_jxc_gtype_all: false,
                jxc_gtype_item: [],
                jxc_gtype_arr: [],
                jxc_goods_name: "",
                jxcExport_allcheck: false,
                c_jxcExport_allcheck: false,
                jxcExport_checkModel: [],
                jxcExport_checkData: ['store_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'start_stock', 'purchase_in', 'give_in', 'transfer_in', 'exchange_in', 'refund_in', 'profit_in', 'legacy_in', 'deposit_in', 'confiscate_in', 'cancel_confiscate_in', 'inventory_profit_in', 'in_total', 'sale_out', 'give_out', 'present_out', 'snack_out', 'transfer_out', 'inventory_losse_out', 'deposit_out', 'confiscate_out', 'cancel_confiscate_out', 'deposit_to_void', 'refund_out', 'receive_out', 'breakage_out', 'out_total', 'end_stock', 'price', 'amount'],
                jxcExport_type: 1,
                total_end_stock: '', //期末总量
                total_in_total: '', //入库总量
                total_out_total: '', //出库总量
                total_amount: '', // 期末总金额
                total_start_stock: '', // 期初总量
                loading: false,
                list_page: 1,
                list_total: 0,
                list_table: [],
                page_size: 10,
                book_export_log_list: [], // 预约导出记录
            }
        },
        watch: {
            jxc_gtype_txt: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.jxc_gtype_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.jxc_gtype_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            jxc_gtype_item: {
                handler: function(val, oldVal) {
                    if(this.jxc_gtype_item.length >= this.jxc_gtype_arr.length) {
                        this.jxc_gtype_all = true;
                        this.c_jxc_gtype_all = true;
                    } else {
                        this.jxc_gtype_all = false;
                        this.c_jxc_gtype_all = false;
                    }
                },
                deep: true
            },
            jxcExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.jxcExport_checkModel.length >= this.jxcExport_checkData.length) {
                        this.jxcExport_allcheck = true;
                        this.c_jxcExport_allcheck = true;
                    } else {
                        this.jxcExport_allcheck = false;
                        this.c_jxcExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.jxc_start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.jxc_end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate();
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.getGoodsType(); // 商品类型
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.jxc_time).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').hour(8).minute(0).toDate(),
                    endDate: moment().hour(8).minute(0).toDate(),
                    maxDate: moment().add(1, 'day').format('YYYY-MM-DD 08:00'),
                }, function(start, end, label) {
                    _this.jxc_start_time = start.format('YYYY-MM-DD 08:00');
                    _this.jxc_end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.jxc_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.jxc_stock).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.jxc_stock).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.jxc_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.jxc_stock).prop("disabled", false);
                            $(_this.$refs.jxc_stock).val('').trigger('change');
                            _this.getstockdata(data.response.result[1].id);
                            _this.getListTable(_this.list_page)
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let boxdatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.jxc_stock).html("");
                $(this.$refs.jxc_stock).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 获取商品类型
            getGoodsType: function() {
                const _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            arr.shift();
                            _this.jxc_gtype_arr = arr;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 清空选项
            clearInput: function() {
                this.jxc_gtype_txt = "";
                this.jxc_gtype_item = [];
            },
            


            // 点击选择商品类型
            jxcGtypeFun: function(e) {
                let _this = this;
                let c_jxc_gtype_item = _this.jxc_gtype_item;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], //按钮
                    title: ['商品类型', true],
                    area: ['700px', ''], //宽高
                    content: $(_this.$refs.jxc_gtype_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.jxc_gtype_txt != "") {
                            _this.jxc_gtype_item = c_jxc_gtype_item;
                            return;
                        }
                        _this.jxc_gtype_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.jxc_gtype_arr.forEach(function(item) {
                        _this.jxc_gtype_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.text);
                            }
                        });
                    });
                    _this.jxc_gtype_txt = texts.join(",");
                    console.log(_this.jxc_gtype_txt);
                    layer.closeAll();
                }, function() {
                    if(_this.jxc_gtype_txt != "") {
                        _this.jxc_gtype_item = c_jxc_gtype_item;
                        return;
                    }
                    _this.jxc_gtype_item = [];
                });
            },
            // 商品属性全选
            jxcGtypeAll: function() {
                let _this = this;
                _this.jxc_gtype_all = _this.c_jxc_gtype_all;
                if(!_this.jxc_gtype_all) { // 实现全选
                    _this.jxc_gtype_item = [];
                    _this.jxc_gtype_arr.forEach(function(item) {
                        _this.jxc_gtype_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.jxc_gtype_item = [];
                }
            },

            getListTable: function(page) {
                let _this = this
                _this.loading = true
                _this.list_page = page
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": page,
                            "page_size": _this.page_size,
                            "start_time": _this.jxc_start_time,
                            "end_time": _this.jxc_end_time,
                            "shop_id": $(_this.$refs.jxc_shop).val(),
                            "store_id": $.trim($(_this.$refs.jxc_stock).val()),
                            "goods_type": _this.jxc_gtype_item,
                            "goods_name": _this.jxc_goods_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPurchaseSaleStock",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if (page == 1) {
                                _this.list_total = Number(data.response.data.total)
                            }
                            _this.list_table = data.response.data.rows
                            _this.total_end_stock = data.response.data.total_end_stock //期末总量
                            _this.total_in_total = data.response.data.total_in_total//入库总量
                            _this.total_out_total = data.response.data.total_out_total //出库总量
                            _this.total_amount = data.response.data.total_amount // 期末总金额
                            _this.total_start_stock = data.response.data.total_start_stock // 期初总量
                            _this.loading = false
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            queryList: function() {
                this.list_page = 1
                this.getListTable(this.list_page)
            },
            // 获取导出设置
            getJxcExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/purchaseSaleStockExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.jxcExport_checkModel = data.response.result.export_fields;
                                _this.jxcExport_type = data.response.result.export_type;
                            } else {
                                _this.jxcExport_checkModel = _this.jxcExport_checkData;
                                _this.jxcExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.jxcExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            jxcExportCheckedAll: function() {
                let _this = this;
                _this.jxcExport_allcheck = _this.c_jxcExport_allcheck;
                if(!_this.jxcExport_allcheck) { // 实现全选
                    _this.jxcExport_checkModel = [];
                    _this.jxcExport_checkData.forEach(function(item) {
                        _this.jxcExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.jxcExport_checkModel = [];
                }
            },

            // 检查导出状态
            checkExport() {
                let _this = this;

                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'purchaseSaleStock',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.page_size,
                            "start_time": _this.jxc_start_time,
                            "end_time": _this.jxc_end_time,
                            "shop_id": $(_this.$refs.jxc_shop).val(),
                            "store_id": $.trim($(_this.$refs.jxc_stock).val()),
                            "goods_type": _this.jxc_gtype_item,
                            "goods_name": _this.jxc_goods_name
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportJxcList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this;
                let export_fields = JSON.stringify(_this.jxcExport_checkModel);

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'purchaseSaleStock',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.page_size,
                            "start_time": _this.jxc_start_time,
                            "end_time": _this.jxc_end_time,
                            "shop_id": $(_this.$refs.jxc_shop).val(),
                            "store_id": $.trim($(_this.$refs.jxc_stock).val()),
                            "goods_type": _this.jxc_gtype_item,
                            "goods_name": _this.jxc_goods_name,
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 点击“导出”按钮
            exportJxcList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.jxcExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/purchaseSaleStockExport" +
                    "?start_time=" + _this.jxc_start_time +
                    "&end_time=" + _this.jxc_end_time +
                    "&shop_id=" + $(_this.$refs.jxc_shop).val() +
                    "&store_id=" + $.trim($(_this.$refs.jxc_stock).val()) +
                    "&goods_type=" + _this.jxc_gtype_item +
                    "&goods_name=" + _this.jxc_goods_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.jxcExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .jxc-list {
        ::-webkit-scrollbar {
            height: 20px;
        }
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 2500px;
                // table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
        .total-row {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .item {
                margin-right: 30px;
            }
        }
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>